import * as angular from "angular";
import {IController} from "angular";
import {LocationType} from "../../../commons/types/location.type";
import {ServiceType} from "../../../deliveries/types/service.type";

export class DispatchStepExternalDialogViewComponent implements IController {

  step: any;
  isOnDemand: boolean;
  quotes: any;
  selectedQuote: any;
  tplProviders: string[];
  selectedTplProvider: any;
  date: any;
  notBefore: any;
  notAfter: any;
  minDate: any;
  isLoadingQuotes: boolean;
  threePlExtraData: any;
  onTplProviderSelect: Function;
  onDateChange: Function;
  onTimeChange: Function;
  onSelectQuote: Function;
  onThreePlExtraDataChange: Function;
  onChangeIsOnDemand: Function;

  public locationTypes: typeof LocationType = LocationType;
  public serviceType: typeof ServiceType = ServiceType;
  public threePlTrailerVehicleNumber: string;

  constructor() {
  }

  $onInit() {
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.threePlExtraData && !changes.threePlExtraData.isFirstChange()) {
      if (this.threePlExtraData?.trailerVehiclePlateNumberList?.length) {
        this.threePlTrailerVehicleNumber = this.threePlExtraData.trailerVehiclePlateNumberList[0];
      }
    }
  }

  onTrailerVehiclePlateNumberChange(threePlTrailerVehicleNumber) {
    if (this.threePlExtraData.trailerVehiclePlateNumberList?.length) {
      this.threePlExtraData.trailerVehiclePlateNumberList.splice(0, 1)
    } else {
      this.threePlExtraData.trailerVehiclePlateNumberList = [];
    }
    this.threePlExtraData.trailerVehiclePlateNumberList.push(threePlTrailerVehicleNumber);
    this.onThreePlExtraDataChange({threePlExtraData: this.threePlExtraData});
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('dispatchStepExternalDialogView', {
    require: {
      form: '^form'
    },
    bindings: {
      step: '<',
      isOnDemand: '<',
      quotes: '<',
      selectedQuote: '<',
      tplProviders: '<',
      selectedTplProvider: '<',
      date: '<',
      notBefore: '<',
      notAfter: '<',
      minDate: '<',
      isLoadingQuotes: '<',
      threePlExtraData: '<',
      onTplProviderSelect: '&',
      onDateChange: '&',
      onTimeChange: '&',
      onSelectQuote: '&',
      onThreePlExtraDataChange: '&',
      onChangeIsOnDemand: '&'
    },
    template: require('./dispatch-step-external-dialog-view.html').default,
    controller: DispatchStepExternalDialogViewComponent
  });
